import styled from 'styled-components';

export const FormattedText = styled.span`
    color: ${props => props.color && props.color !== null ? props.color : '#000'};
    font-family: ${props => props.fontFamily && props.fontFamily !== null ? props.fontFamily : '"ADazzed-Medium"'};
    font-size: ${props => props.fontSize && props.fontSize !== null ? props.fontSize : '1rem'};
    font-display: swap;
    letter-spacing: ${props => props.letterSpacing && props.letterSpacing !== null ? props.letterSpacing : 'normal'};
    line-height: ${props => props.lineHeight && props.lineHeight !== null ? props.lineHeight : 'normal'};
`;